// Supplier directory

function initSupplierArchiveFiltersAccordion() {
  const root = document.getElementById("supplier-archive-filters");
  if (!root || !window.matchMedia) {
    return;
  }

  const heading = root.querySelector(".js-toggle");
  const panel = heading?.nextElementSibling;
  if (!heading || !panel?.classList.contains("toggle-container")) {
    return;
  }

  const mq = window.matchMedia("(min-width: 1024px)");

  const setDesktopOpen = () => {
    panel.classList.add("active", "open");
    heading.classList.add("active");
    panel.style.height = `${panel.scrollHeight}px`;
  };

  const setMobileClosed = () => {
    heading.classList.remove("active");
    panel.classList.remove("active", "open");
    panel.style.height = "0px";
  };

  const syncLayout = () => {
    if (mq.matches) {
      setDesktopOpen();
    } else {
      setMobileClosed();
    }
  };

  heading.addEventListener("click", function (event) {
    event.preventDefault();
    if (mq.matches) {
      return;
    }

    const isOpen = panel.classList.contains("active");

    if (!isOpen) {
      panel.classList.add("active", "open");
      heading.classList.add("active");
      panel.style.height = `${panel.scrollHeight}px`;
    } else {
      panel.classList.remove("active", "open");
      heading.classList.remove("active");
      panel.style.height = "0px";
    }
  });

  mq.addEventListener("change", syncLayout);
  syncLayout();
}

export function supplierAjaxPosts() {
  document.addEventListener("DOMContentLoaded", function () {
    initSupplierArchiveFiltersAccordion();

    const supplierList = document.getElementById("supplier-list");
    const loadBtn = document.getElementById("load-more-suppliers");
    const sortSelect = document.getElementById("sort-suppliers");
    const sectorSelect = document.getElementById("filter-sector");
    const regionSelect = document.getElementById("filter-region");
    const loadMoreContainer = document.getElementById("load-more-container");
    const noSuppliersMsg = document.getElementById("no-suppliers-message");

    let currentPage = 1;
    let currentSort = sortSelect ? sortSelect.value : "newest";
    let supplierCount = 0;

    if (!supplierList || !loadBtn) {
      return;
    }

    const skipInitialAjax = Boolean(loadMoreContainer?.hidden);

    function fetchSuppliers(reset = false) {
      if (reset) {
        supplierList.innerHTML = "";
        currentPage = 1;
        supplierCount = 0;
        loadBtn.dataset.page = 1;
      }

      loadBtn.classList.add("loading");
      loadBtn.textContent = "Loading...";
      supplierList.classList.add("loading");

      fetch(wpData.ajaxUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          action: "load_more_suppliers",
          page: currentPage,
          sort: currentSort,
          term_id: loadBtn.dataset.termId || "",
          taxonomy: loadBtn.dataset.taxonomy || "",
          search: loadBtn.dataset.search || "",
          sector: loadBtn.dataset.sector || "",
          region: loadBtn.dataset.region || "",
          context: loadBtn.dataset.context || "search",
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success && data.data.total > 0) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = data.data.html;

            const newCards = tempDiv.querySelectorAll(
              ".supplier-card:not(.join-card)"
            );
            supplierCount += newCards.length;

            const countDisplay = document.getElementById("supplier-count");
            if (countDisplay) {
              countDisplay.textContent = `Showing 1–${supplierCount} of ${data.data.total} suppliers`;
            }

            supplierList.insertAdjacentHTML("beforeend", data.data.html);

            if (window.lazyLoadInstance) {
              window.lazyLoadInstance.update();
            }

            currentPage = data.data.paged;
            loadBtn.dataset.page = currentPage;

            const donePaging = currentPage >= data.data.max;
            if (loadMoreContainer) {
              loadMoreContainer.hidden = donePaging;
            }
            loadBtn.style.display = donePaging ? "none" : "inline-block";
            if (!donePaging) {
              loadBtn.textContent = "Load More";
            }

            if (noSuppliersMsg) noSuppliersMsg.classList.add("hidden");
          } else {
            if (loadMoreContainer) {
              loadMoreContainer.hidden = true;
            }
            loadBtn.style.display = "none";
            if (noSuppliersMsg) noSuppliersMsg.classList.remove("hidden");
          }
        })
        .finally(() => {
          supplierList.classList.remove("loading");
          loadBtn.classList.remove("loading");
        });
    }

    loadBtn.addEventListener("click", function () {
      currentPage++;
      fetchSuppliers();
    });

    if (sortSelect) {
      sortSelect.addEventListener("change", function () {
        currentSort = this.value;
        fetchSuppliers(true);
      });
    }

    if (sectorSelect) {
      sectorSelect.addEventListener("change", function () {
        loadBtn.dataset.sector = this.value;
        fetchSuppliers(true);
      });
    }

    if (regionSelect) {
      regionSelect.addEventListener("change", function () {
        loadBtn.dataset.region = this.value;
        fetchSuppliers(true);
      });
    }

    if (!skipInitialAjax) {
      fetchSuppliers(true);
    }
  });
}
